module.exports = "https://static.wmbcdn.com/uniweb/images/382d0afa59151bc590af2a821ea15cc2.svg";